import { Component, OnInit } from '@angular/core';
import { TemplatesFacade } from '@quorum/xsr-template-library';
import { templateActions } from '@quorum/sha-entities/quorum';

@Component({
  selector: 'quorum-quorum-gallery',
  templateUrl: './quorum-gallery.component.html',
  styleUrls: ['./quorum-gallery.component.scss'],
})
export class QuorumGalleryComponent implements OnInit {
  constructor(public templatesFacade: TemplatesFacade) {}

  ngOnInit(): void {
    this.templatesFacade.dispatch(templateActions.GetQuorumGalleryTemplatesFromServer({}));
    this.templatesFacade.dispatch(templateActions.GetQuorumLibraryTemplatesFromServer({}));
    this.setLanguage('en');

    //  actions.push(templateActions.loadMessageTypesFromServer({}));
    //  actions.push(templateActions.GetStoreGalleryTemplatesFromServer({ custId: authenticatedUser.user.destination }));
    //  actions.push(templateActions.GetQuorumGalleryTemplatesFromServer({}));
    //  actions.push(
    //    messageTypeToTemplateMappingActions.GetMessageTypeToTemplateMappingsFromServer({
    //      custId: authenticatedUser.user.destination,
    //    })
    //  );
  }

  setLanguage(language: string) {
    this.templatesFacade.selectLanguage(language);
  }
}
